<template>
  <div class="app__buttons-group buttons-group" :data-type="structure.type">
    <GameButton
      :data="{
        content: $translate('questions')[structure.id].answers[0],
        type: structure.type,
        value: 0,
      }"
    />

    <div class="boolean__line" v-if="structure.type === 'boolean'">
      <img src="/img/svg/line.svg">
    </div>

    <GameButton
      :data="{
        content: $translate('questions')[structure.id].answers[1],
        type: structure.type,
        value: 1,
      }"
    />
  </div>
</template>

<script>
import GameButton from '@/components/GameButton.vue';

export default {
  name: 'GameButtonGroup',

  components: {
    GameButton,
  },

  props: {
    structure: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons-group {
  width: 100%;
  height: 100%;
  display: flex;

  & ::v-deep button:first-child svg {
    fill: $color-yellow;
  }

  & ::v-deep button:last-child svg {
    fill: $color-blue;
  }

  &[data-type="boolean"] {
    align-items: flex-start;
    justify-content: space-around;

    & ::v-deep .boolean__line {
      margin: 0;

      img {
        transform: scaleX(-1) translateY(20px);
        width: calc(var(--unit-vw) * 0.8);
      }
    }
  }

  &[data-type="button"] {
    align-items: flex-start;
    justify-content: space-between;
    flex-flow: column nowrap;

    & ::v-deep button:last-child {
      margin-left: auto;
      margin-top: calc(var(--unit-vh) * -1.5);
    }
  }

  @include mq($until: ipadP) {
    &[data-type="boolean"] {
      .boolean__line {
        position: relative;
        margin-top: calc(var(--unit-vh) * 1.5);
        transform: rotate(90deg);
      }

      button:last-child {
        margin-top: calc(var(--unit-vh) * 2);
      }
    }
  }

  @include mq(ipadP) {
    &[data-type="boolean"] {
      align-items: center;

      & ::v-deep .boolean__line img {
        transform: none;
      }
    }

    &[data-type="button"] {
      flex-flow: row wrap;
    }

    &[data-type="button"] {
      button:first-child {
        margin: calc(var(--unit-vh) * 0.6) 0 0 calc(var(--unit-vw) * 0.8);
      }

      button:last-child {
        margin: calc(var(--unit-vh) * 1.2) calc(var(--unit-vw) * 0.8) 0 0;
      }
    }
  }
}
</style>
